import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Box,
    Typography, Rating, Button,useMediaQuery
} from "@mui/material";
import { Formik } from 'formik';
import * as Yup from 'yup';
import StarIcon from '@mui/icons-material/Star';
function ServiceStep4({ onNext,onPrevious,formData,fetchMedia }) {
    // console.log("formData 4 th step",formData)
    const [value, setValue] = useState(1);
    const isMobile = useMediaQuery('(max-width:600px)');
    
    return (
        <>
            <Box p={isMobile?0:2}>
                <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                    <Typography variant={isMobile?"body1":"h6"} fontWeight={"bold"} textTransform={"capitalize"}>We’ll send you gear and iPhone settings for the best low-budget setup.</Typography>
                </Grid>
                <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                    <Typography variant="body2" textTransform={"capitalize"}> How confident are you on camera? (Scale of 1 to 5 — we’ll coach you as needed!)</Typography>
                </Grid>
                <Formik
                    initialValues={{
                        camera_rating: formData ? formData.camera_rating ? formData.camera_rating:null: null,
                    }}
                    // validationSchema={validationSchema}
                    onSubmit={(values, errors) => {
                        console.log(values);
                        onNext(values);
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, setFieldValue ,touched }) => (
                        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                            <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                                <Box position="relative" display="inline-block" width={isMobile?"100%":"50%"}>
                                    <Box display="flex" justifyContent="center">
                                        <Rating
                                            name="camera_rating"
                                            value={values.camera_rating}
                                            onChange={(event, newValue) => setFieldValue("camera_rating", newValue)}
                                            precision={1}
                                            icon={<StarIcon style={{ fontSize:isMobile?"60px": "50px" }} htmlColor="#ffc107" />}
                                            emptyIcon={<StarIcon style={{ fontSize:isMobile?"60px": "50px" }} htmlColor="#ccc" />}
                                        />
                                    </Box>
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        width="100%"
                                        sx={{ paddingLeft: "40px", paddingRight: "18px" }}
                                        mt={1}
                                    >
                                        <Typography>Nervous</Typography>
                                        <Typography>Confident AF</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={isMobile?"center":"left"}gap={2} mt={2}>
                                <Button variant="contained" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} type='submit'>NEXT</Button>
                                <Button variant="outlined" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} onClick={() => onNext()}>SKIP</Button>
                                <Button variant="text" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} onClick={onPrevious}>previous step</Button>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Box>
        </>
    )
}
export default ServiceStep4;